module.exports = __webpack_public_path__ + "img/subscription.2776636a.png";